import { FC, ReactNode } from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import {
  basePath, signInPath, signUpPath, withBasePath,
} from 'src/routes/constants';

const CLERK_PUB_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!CLERK_PUB_KEY) {
  throw new Error('Missing Clerk Publishable Key');
}

// Under a base path, Clerk's own redirects need it too; at the root, Clerk keeps the paths set on the instance.
const basePathUrls = basePath ? {
  signInUrl: withBasePath(signInPath),
  signUpUrl: withBasePath(signUpPath),
  afterSignOutUrl: withBasePath('/'),
} : {};

type AuthProviderProps = {
  children: ReactNode;
};

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => (
  <ClerkProvider publishableKey={CLERK_PUB_KEY} {...basePathUrls}>{children}</ClerkProvider>
);
